
/* -- THIS IS A GENERATED FILE BY @relay -- */
import { ComponentRegistration } from '@relay/client';

export const registrations: ComponentRegistration[] = [
{
  name: 'InteractiveClick',
  import: (): Promise<any> => import('C:/agent/_work/11085/s/src/ui/src/stories/__tests__/InteractiveClick/InteractiveClick.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'Testimonials',
  import: (): Promise<any> => import('C:/agent/_work/11085/s/src/ui/src/stories/widgets/Testimonials/Testimonials.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'StatsColumns',
  import: (): Promise<any> => import('C:/agent/_work/11085/s/src/ui/src/stories/widgets/StatsColumns/StatsColumns.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'Timeline',
  import: (): Promise<any> => import('C:/agent/_work/11085/s/src/ui/src/stories/widgets/Timeline/Timeline.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'SimilarCaseStudies',
  import: (): Promise<any> => import('C:/agent/_work/11085/s/src/ui/src/stories/widgets/SimilarCaseStudies/SimilarCaseStudies.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'Services',
  import: (): Promise<any> => import('C:/agent/_work/11085/s/src/ui/src/stories/widgets/Services/Services.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'PulledOutQuote',
  import: (): Promise<any> => import('C:/agent/_work/11085/s/src/ui/src/stories/widgets/PulledOutQuote/PulledOutQuote.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'PeopleList',
  import: (): Promise<any> => import('C:/agent/_work/11085/s/src/ui/src/stories/widgets/PeopleList/PeopleList.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ModalContactForm',
  import: (): Promise<any> => import('C:/agent/_work/11085/s/src/ui/src/stories/widgets/ModalContactForm/ModalContactForm.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'MediaFeature',
  import: (): Promise<any> => import('C:/agent/_work/11085/s/src/ui/src/stories/widgets/MediaFeature/MediaFeature.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'LatestInsights',
  import: (): Promise<any> => import('C:/agent/_work/11085/s/src/ui/src/stories/widgets/LatestInsights/LatestInsights.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'InnerPageHeader',
  import: (): Promise<any> => import('C:/agent/_work/11085/s/src/ui/src/stories/widgets/InnerPageHeader/InnerPageHeader.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'IconList',
  import: (): Promise<any> => import('C:/agent/_work/11085/s/src/ui/src/stories/widgets/IconList/IconList.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'HomepageHero',
  import: (): Promise<any> => import('C:/agent/_work/11085/s/src/ui/src/stories/widgets/HomepageHero/HomepageHero.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'GetInTouch',
  import: (): Promise<any> => import('C:/agent/_work/11085/s/src/ui/src/stories/widgets/GetInTouch/GetInTouch.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'FiftyFifty',
  import: (): Promise<any> => import('C:/agent/_work/11085/s/src/ui/src/stories/widgets/FiftyFifty/FiftyFifty.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'Faqs',
  import: (): Promise<any> => import('C:/agent/_work/11085/s/src/ui/src/stories/widgets/Faqs/Faqs.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ContactForm',
  import: (): Promise<any> => import('C:/agent/_work/11085/s/src/ui/src/stories/widgets/ContactForm/ContactForm.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'CategoryCardLinks',
  import: (): Promise<any> => import('C:/agent/_work/11085/s/src/ui/src/stories/widgets/CategoryCardLinks/CategoryCardLinks.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'CaseStudyList',
  import: (): Promise<any> => import('C:/agent/_work/11085/s/src/ui/src/stories/widgets/CaseStudyList/CaseStudyList.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'CaseStudyHeader',
  import: (): Promise<any> => import('C:/agent/_work/11085/s/src/ui/src/stories/widgets/CaseStudyHeader/CaseStudyHeader.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'ArticleList',
  import: (): Promise<any> => import('C:/agent/_work/11085/s/src/ui/src/stories/widgets/ArticleList/ArticleList.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'ArticleHeader',
  import: (): Promise<any> => import('C:/agent/_work/11085/s/src/ui/src/stories/widgets/ArticleHeader/ArticleHeader.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ArticleDetail',
  import: (): Promise<any> => import('C:/agent/_work/11085/s/src/ui/src/stories/widgets/ArticleDetail/ArticleDetail.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'VideoEmbed',
  import: (): Promise<any> => import('C:/agent/_work/11085/s/src/ui/src/stories/components/VideoEmbed/VideoEmbed.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'FeaturedArticles',
  import: (): Promise<any> => import('C:/agent/_work/11085/s/src/ui/src/stories/components/FeaturedArticles/FeaturedArticles.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'Modal',
  import: (): Promise<any> => import('C:/agent/_work/11085/s/src/ui/src/stories/components/Modal/Modal.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'List',
  import: (): Promise<any> => import('C:/agent/_work/11085/s/src/ui/src/stories/widgets/Locations/List/List.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'HeaderCta',
  import: (): Promise<any> => import('C:/agent/_work/11085/s/src/ui/src/stories/widgets/global/Header/HeaderCta.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'SvgColumnedMask',
  import: (): Promise<any> => import('C:/agent/_work/11085/s/src/ui/src/stories/components/misc/SvgColumnedMask/SvgColumnedMask.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'LabsGridOverlay',
  import: (): Promise<any> => import('C:/agent/_work/11085/s/src/ui/src/stories/components/misc/LabsGridOverlay/LabsGridOverlay.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'FormRow',
  import: (): Promise<any> => import('C:/agent/_work/11085/s/src/ui/src/stories/components/misc/forms/FormRow.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'FormField',
  import: (): Promise<any> => import('C:/agent/_work/11085/s/src/ui/src/stories/components/misc/forms/FormField.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'Form',
  import: (): Promise<any> => import('C:/agent/_work/11085/s/src/ui/src/stories/components/misc/forms/Form.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'CountUp',
  import: (): Promise<any> => import('C:/agent/_work/11085/s/src/ui/src/stories/components/misc/CountUp/CountUp.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'AccordionComponent',
  import: (): Promise<any> => import('C:/agent/_work/11085/s/src/ui/src/stories/components/misc/AccordionComponent/AccordionComponent.client'),
  config: {
  hydrate: 'click',
},
},
  {
  name: 'TestimonialCard',
  import: (): Promise<any> => import('C:/agent/_work/11085/s/src/ui/src/stories/components/cards/TestimonialCard/TestimonialCard.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'Button',
  import: (): Promise<any> => import('C:/agent/_work/11085/s/src/ui/src/stories/components/buttons/Button/Button.client'),
  config: {
  hydrate: 'click',
},
},
  {
  name: 'Navigation',
  import: (): Promise<any> => import('C:/agent/_work/11085/s/src/ui/src/stories/widgets/global/Header/Navigation/Navigation.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'LinkGroups',
  import: (): Promise<any> => import('C:/agent/_work/11085/s/src/ui/src/stories/widgets/global/Footer/LinkGroups/LinkGroups.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'CookieSettings',
  import: (): Promise<any> => import('C:/agent/_work/11085/s/src/ui/src/stories/widgets/global/Footer/CookieSettings/CookieSettings.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'NewsletterForm',
  import: (): Promise<any> => import('C:/agent/_work/11085/s/src/ui/src/stories/components/misc/forms/NewsletterForm/NewsletterForm.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'ContactFormComponent',
  import: (): Promise<any> => import('C:/agent/_work/11085/s/src/ui/src/stories/components/misc/forms/ContactFormComponent/ContactFormComponent.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'FilterTray',
  import: (): Promise<any> => import('C:/agent/_work/11085/s/src/ui/src/stories/components/misc/filters/FilterTray/FilterTray.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'FullWidthCarousel',
  import: (): Promise<any> => import('C:/agent/_work/11085/s/src/ui/src/stories/components/misc/carousels/FullWidthCarousel/FullWidthCarousel.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'FilterBar',
  import: (): Promise<any> => import('C:/agent/_work/11085/s/src/ui/src/stories/components/misc/filters/FilterBar/FilterBar.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'Item',
  import: (): Promise<any> => import('C:/agent/_work/11085/s/src/ui/src/stories/components/misc/AccordionComponent/Item/Item.client'),
  config: {
  hydrate: 'click',
},
},
  {
  name: 'Column',
  import: (): Promise<any> => import('C:/agent/_work/11085/s/src/ui/src/stories/widgets/global/Header/Navigation/Column/Column.client'),
  config: {
  hydrate: 'click',
},
},
  {
  name: 'Textbox',
  import: (): Promise<any> => import('C:/agent/_work/11085/s/src/ui/src/stories/components/misc/forms/inputs/Textbox/Textbox.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'Textarea',
  import: (): Promise<any> => import('C:/agent/_work/11085/s/src/ui/src/stories/components/misc/forms/inputs/Textarea/Textarea.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'Recaptcha2',
  import: (): Promise<any> => import('C:/agent/_work/11085/s/src/ui/src/stories/components/misc/forms/inputs/Recaptcha2/Recaptcha2.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'Select',
  import: (): Promise<any> => import('C:/agent/_work/11085/s/src/ui/src/stories/components/misc/forms/inputs/Select/Select.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'RadioList',
  import: (): Promise<any> => import('C:/agent/_work/11085/s/src/ui/src/stories/components/misc/forms/inputs/RadioList/RadioList.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'Date',
  import: (): Promise<any> => import('C:/agent/_work/11085/s/src/ui/src/stories/components/misc/forms/inputs/Date/Date.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'CheckboxList',
  import: (): Promise<any> => import('C:/agent/_work/11085/s/src/ui/src/stories/components/misc/forms/inputs/CheckboxList/CheckboxList.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'Pagination',
  import: (): Promise<any> => import('C:/agent/_work/11085/s/src/ui/src/stories/components/misc/carousels/Carousel/Pagination/Pagination.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'Controls',
  import: (): Promise<any> => import('C:/agent/_work/11085/s/src/ui/src/stories/components/misc/carousels/Carousel/Controls/Controls.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'LiveRegion',
  import: (): Promise<any> => import('C:/agent/_work/11085/s/src/ui/src/stories/components/misc/carousels/Carousel/LiveRegion/LiveRegion.client'),
  config: {
    hydrate: 'in-view',
  },
} 
];
  